import { render, staticRenderFns } from "./CourierTable.vue?vue&type=template&id=cb28f062&scoped=true&"
import script from "./CourierTable.vue?vue&type=script&lang=js&"
export * from "./CourierTable.vue?vue&type=script&lang=js&"
import style0 from "./CourierTable.vue?vue&type=style&index=0&id=cb28f062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb28f062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
